module.exports = __webpack_public_path__ + "static/team_neggin-8705aff6326c822863184e05503ac10e.jpg";